import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import Toast from 'react-native-toast-message';

import { useSafeViewport } from '../../utils/hooks/useSafeViewport';
import { getInsetAdjustedOffset } from '../../utils/safeArea';
import { globalBroadcastToastConfig } from './globalBroadcastToastConfig';

type BroadcastToastHostProps = {
	/** Render above game WebView (native) or as app overlay (web). */
	variant?: 'game' | 'app';
};

/**
 * Dedicated Toast layer for site-wide game broadcasts.
 * On native, mount inside GameTable above WebView — hardware WebView covers siblings in modals.
 */
export function BroadcastToastHost({ variant = 'app' }: BroadcastToastHostProps) {
	const isGame = variant === 'game';
	const { insets } = useSafeViewport();
	const topOffset = getInsetAdjustedOffset(insets.top, Platform.OS === 'web' ? 56 : 12);

	return (
		<View
			pointerEvents='box-none'
			style={isGame ? styles.gameHost : styles.appHost}
			collapsable={false}
		>
			<Toast
				config={globalBroadcastToastConfig}
				position='top'
				topOffset={topOffset}
				visibilityTime={10_000}
			/>
		</View>
	);
}

const styles = StyleSheet.create({
	appHost: {
		...StyleSheet.absoluteFill,
		justifyContent: 'flex-start',
		alignItems: 'center',
		zIndex: 999999,
		elevation: 999999,
	},
	gameHost: {
		...StyleSheet.absoluteFill,
		justifyContent: 'flex-start',
		alignItems: 'center',
		zIndex: 100000,
		elevation: 100000,
	},
});
